import React from 'react';

const OurEvents = () => {
  return (
    <section className="section" id="trainers">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div className="section-heading">
              <h2>Our <em>Events</em></h2>
              <img src="assets/images/line-dec.png" alt="" />
              <p>We major in Coffees and Cocktails on; Showers - Birthday, Baby showers, Bridal, House Parties, Wedding Ceremonies, Engagements, Conferences and many more....</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <div className="trainer-item">
              <div className="image-thumb">
                <img src="assets/images/vvipcar.jpg" alt="" />
              </div>
              <div className="down-content">
                <span>
                  {/* <sup>$</sup>1500.00 - <sup>$</sup>3500.00 */}
                </span>

                <h4>Mobile Coffee Bar</h4>

                <p>VVIP Mobile Coffee Bar is a movable Beverage cart that’s hand driven on Wheels to serve Functions and Events.</p>

                <ul className="social-icons">
                  <li><a href="/bookings">+ Make a Booking</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="trainer-item">
              <div className="image-thumb">
                <img src="assets/images/vvipgals.jpg" alt="" />
              </div>
              <div className="down-content">
                <span>
                  {/* <sup>$</sup>1500.00 - <sup>$</sup>3500.00 */}
                </span>

                <h4>Personal Birthdays</h4>

                <p>We can bring delight to your special birthday present with amazing coffee and cocktails. A service of a life time that you will remember.</p>

                <ul className="social-icons">
                  <li><a href="/bookings">+ Make a Booking</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="trainer-item">
              <div className="image-thumb">
                <img src="assets/images/vvipcapcino.jpg" alt="" />
              </div>
              <div className="down-content">
                <span>
                  {/* <sup>$</sup>1500.00 - <sup>$</sup>3500.00 */}
                </span>

                <h4>Just Call us</h4>

                <p>Or you can still contact us directly and we discuss whatever special occasion that you have and we will come up with something just right for you.</p>

                <ul className="social-icons">
                  <li><a href="/bookings">+ Make a Booking</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <br />

        <div className="main-button text-center">
          <a href="/menu">View our Products</a>
        </div>
      </div>
    </section>
  )
};

export default OurEvents;
